import { render, staticRenderFns } from "./TopBarRoot.vue?vue&type=template&id=caa8337c"
import script from "./TopBarRoot.vue?vue&type=script&lang=ts"
export * from "./TopBarRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports